import { BreadCrumb } from "primereact/breadcrumb";
import React, { useEffect, useState } from "react";
import {
	Breadcrumbs,
	Button,
	DateRangePicker,
	Modal,
	MultiSelect,
	Select,
	SliderComponent,
	Textarea,
	Textfield,
	Timepicker,
	Tooltip,
} from "../../../../../components/core";
import { ContentContainer } from "../../../../../components/layout";
import { InputText } from "primereact/inputtext";
import DateRangeTimePicker from "../../../../../components/core/date-range-with-time-picker";
import { InputNumber } from "primereact/inputnumber";
import TextFieldDropdown from "../../../../../components/core/text-field-with-dropdown";
import { Divider } from "primereact/divider";
import { Card } from "primereact/card";
import { InputTextarea } from "primereact/inputtextarea";
import { useQuery } from "@apollo/client";
import { LOCKER_INFO } from "../../../../../constants/graphql/locker-queries";
import { Strings } from "../../../../../constants/strings";

const AddRedemptionCodeCampaign = () => {
	const [lockerName, setLockerName] = useState([]);
	const [operatorID, setOperatorID] = useState("");
	const [allLockersSelected, setAllLockersSelected] = useState(false);
	const [isSaveDialogOpen, setShowSaveDialogOpen] = useState(false);
	const [isCopied, setIsCopied] = useState(false);
	const [selectedReward, setSelectedReward] = useState({
		label: "MBOX coins",
		value: 1,
	});
	const [errorValidation, setErrorValidation] = useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "Invalid data",
		message: "",
		open: false,
		actions: "",
	});

	const [addRedemptionVars, setAddRedemptionVars] = useState({
		campaignName: "",
		startDate: "",
		startTime: "",
		endDate: "",
		endTime: "",
		lockerId: [],
		redemptionLimit: {
			campaign: null,
			person: null,
		},
		redemptionCode: "",
		rewardType: null,
		rewardTypeStr: selectedReward.label,
		remarks: "",
	});
	const home = {
		icon: "pi pi-home",
		url: `${process.env.REACT_APP_BASE_ENVIRONMENT}mbox-redemption-code-campaigns`,
	};
	const breadcrumbItems = [
		{ label: "Add Redemption Code Campaign", path: "#" },
	];

	const { data: allLockerNames } = useQuery(LOCKER_INFO, {
		variables: { operatorId: operatorID },
	});

	useEffect(() => {
		if (allLockerNames && allLockerNames.lockerInfo) {
			// let tempData = [
			// 	{
			// 		value: 0,
			// 		label: "All Lockers",
			// 	},
			// ];
			let tempData = [];

			allLockerNames.lockerInfo.forEach((element) => {
				tempData.push({
					value: element.lockerId,
					label: element.lockerName,
				});
			});

			if (!allLockersSelected) {
				tempData.unshift({
					value: 0,
					label: "All Lockers",
				});
			}

			setLockerName(tempData);
		}
	}, [allLockerNames, allLockersSelected]);

	useEffect(() => {
		let opIDLocal = localStorage.getItem("user");

		let opIDLocal2 = JSON.parse(opIDLocal);
		// console.log({ opIDLocal2 });

		setOperatorID(opIDLocal2.operator_id);
	}, []);

	// console.log({ lockerName });

	const handleChange = (event) => {
		const { name, value } = event.target;
		const keys = name.split(".");
		// console.log({ event, value });
		if (keys.length === 2) {
			// Nested property update
			const updatedValue = value === 0 ? " " : value;
			setAddRedemptionVars((prevState) => ({
				...prevState,
				[keys[0]]: {
					...prevState[keys[0]],
					[keys[1]]: updatedValue?.toString(),
				},
			}));
		} else {
			// Regular property update
			setAddRedemptionVars((prevState) => ({
				...prevState,
				[name]: value,
			}));
		}
	};

	const copyToClipboard = () => {
		navigator.clipboard
			.writeText(addRedemptionVars.redemptionCode)
			.then(() => {
				setIsCopied(true);
				setTimeout(() => {
					setIsCopied(false);
				}, 1000);
			})
			.catch((error) => {
				console.error("Error copying text: ", error);
			});
	};

	const validateFields = () => {
		let startDateTime = new Date(
			`${addRedemptionVars.startDate}T${addRedemptionVars.startTime}`
		);
		let endDateTime = new Date(
			`${addRedemptionVars.endDate}T${addRedemptionVars.endTime}`
		);

		console.log({ startDateTime, endDateTime });

		if (
			addRedemptionVars.campaignName === "" ||
			addRedemptionVars.startDate === "" ||
			addRedemptionVars.endDate === "" ||
			addRedemptionVars.startTime === "" ||
			addRedemptionVars.endTime === "" ||
			addRedemptionVars.lockerId.length === 0 ||
			addRedemptionVars.redemptionLimit.campaign === null ||
			addRedemptionVars.redemptionLimit.person === null ||
			addRedemptionVars.redemptionCode === ""
			// addRedemptionVars.rewardType === null
		) {
			setErrorValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Incomplete Fields",
				message: "Please fill out all the fields to proceed",
				open: true,
				actions: (
					<div className="grid grid-cols-1">
						<Button
							onClick={() => setErrorValidation({ open: false })}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				),
			});
		} else if (
			new Date(addRedemptionVars.startDate) >
			new Date(addRedemptionVars.endDate)
		) {
			setErrorValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Invalid Campaign Date",
				message: "End date cannot be later than start date.",
				open: true,
				actions: (
					<div className="grid grid-cols-1">
						<Button
							onClick={() => setErrorValidation({ open: false })}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				),
			});
		} else if (startDateTime > endDateTime) {
			setErrorValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Invalid Campaign Time",
				message: "End time cannot be greater than start time on the same day.",
				open: true,
				actions: (
					<div className="grid grid-cols-1">
						<Button
							onClick={() => setErrorValidation({ open: false })}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				),
			});
		} else if (startDateTime.getTime() === endDateTime.getTime()) {
			setErrorValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Invalid Campaign Time",
				message: "End time cannot be equal to start time on the same day.",
				open: true,
				actions: (
					<div className="grid grid-cols-1">
						<Button
							onClick={() => setErrorValidation({ open: false })}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				),
			});
		} else {
			// setShowSaveDialogOpen(true);

			setErrorValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
				title: Strings.popup_confirm_save_title,
				message: Strings.popup_confirm_save_massage,
				open: true,
				actions: (
					<div className="grid grid-cols-2 gap-2">
						<Button
							onClick={() => setErrorValidation({ open: false })}
							value={"No"}
							className={"p-2"}
						/>
						<Button
							onClick={() => {
								// console.log("why");
								handleSaveChanges();
							}}
							value={"Yes"}
							className={"p-2"}
							// disabled={
							// 	accessPermission.lockerUserType === 1 ||
							// 	accessPermission.lockerUserType === "1"
							// }
						/>
					</div>
				),
			});
		}
	};

	useEffect(() => {
		const hasZeroValue = addRedemptionVars.lockerId.some(
			(item) => item.value === 0
		);

		if (hasZeroValue) {
			// console.log("heyyyy");
			setAllLockersSelected(true);
		}

		if (addRedemptionVars.lockerId.length === 0) {
			setAllLockersSelected(false);
		}
	}, [addRedemptionVars.lockerId]);

	console.log({ allLockersSelected });
	useEffect(() => {
		if (allLockersSelected) {
			const selectedLockers = lockerName.filter((locker) => locker.value !== 0);

			setAddRedemptionVars((prevState) => ({
				...prevState,
				lockerId: selectedLockers,
			}));

			// setLockerName([]);
		} else {
			setAddRedemptionVars((prevState) => ({
				...prevState,
				lockerId: [],
			}));
		}
	}, [allLockersSelected, lockerName]);

	// console.log({ selectedReward });

	const handleSaveChanges = () => {
		if (allLockersSelected) {
			let inputValues = [
				{
					campaignName: addRedemptionVars.campaignName,
					lockerId: 0,
					startDateTime:
						addRedemptionVars.startDate + "[T]" + addRedemptionVars.startTime,
					endDateTime:
						addRedemptionVars.endDate + "[T]" + addRedemptionVars.endTime,
					redemptionLimit: {
						campaign:
							addRedemptionVars.redemptionLimit.campaign === " "
								? "0"
								: addRedemptionVars.redemptionLimit.campaign,
						person:
							addRedemptionVars.redemptionLimit.person === " "
								? "0"
								: addRedemptionVars.redemptionLimit.person,
					},
					redemptionCode: addRedemptionVars.redemptionCode,
					rewardType: addRedemptionVars.rewardType,
					remarks: addRedemptionVars.remarks,
				},
			];

			console.log({ inputValues });

			console.log("--- CALL ---");
		} else {
			let inputValues = [
				{
					campaignName: addRedemptionVars.campaignName,
					lockerId: addRedemptionVars.lockerId,
					startDateTime:
						addRedemptionVars.startDate + "[T]" + addRedemptionVars.startTime,
					endDateTime:
						addRedemptionVars.endDate + "[T]" + addRedemptionVars.endTime,
					redemptionLimit: {
						campaign:
							addRedemptionVars.redemptionLimit.campaign === " "
								? "0"
								: addRedemptionVars.redemptionLimit.campaign,
						person:
							addRedemptionVars.redemptionLimit.person === " "
								? "0"
								: addRedemptionVars.redemptionLimit.person,
					},
					redemptionCode: addRedemptionVars.redemptionCode,
					rewardType: addRedemptionVars.rewardType,
					remarks: addRedemptionVars.remarks,
				},
			];
			console.log({ inputValues });

			console.log("--- CALL ---");
		}
	};

	console.log({ addRedemptionVars, selectedReward });

	return (
		<>
			<ContentContainer>
				<div className="w-full">
					<BreadCrumb
						home={home}
						model={breadcrumbItems}
						className="p-3 outline outline-1 outline-primary-primaryYellow"
					></BreadCrumb>

					<div className="h-full w-full px-2">
						<div className="text-xl font-bold pt-3">
							New Redemption Code Campaign
						</div>

						<div className="w-full py-2">
							{/* <div className="font-semibold">Promotion Details:</div> */}

							<div className="flex flex-col gap-3 px-[1.25rem]">
								<div className="grid grid-cols-12 w-full gap-3 items-center">
									<div className="col-span-6">
										<div className="grid grid-cols-12  items-center">
											<div className="col-span-4">
												<label>Campaign Name:</label>
											</div>
											<div className={"col-span-8"}>
												<Textfield
													name={"campaignName"}
													value={addRedemptionVars.campaignName}
													onChange={(event) => handleChange(event)}
												/>
											</div>
										</div>
									</div>
								</div>

								<div className="grid grid-cols-12 w-full gap-3 items-center">
									<div className="col-span-6">
										<div className="grid grid-cols-12  items-center">
											<div className="col-span-4">
												<label>Campaign Date:</label>
											</div>
											<div className={"col-span-8"}>
												<DateRangeTimePicker
													startDateName="startDate"
													endDateName="endDate"
													startTimeName="startTime"
													endTimeName="endTime"
													startDate={addRedemptionVars.startDate}
													endDate={addRedemptionVars.endDate}
													startTime={addRedemptionVars.startTime}
													endTime={addRedemptionVars.endTime}
													onChange={handleChange}
												/>
											</div>
										</div>
									</div>
								</div>

								<div className="grid grid-cols-12 w-full gap-3 items-center">
									<div className="col-span-6 ">
										{/* <div className="gap-2 items-center"> */}
										<div className="grid grid-cols-12  items-center">
											<label className="col-span-4">Locker Name:</label>

											<div className="col-span-8">
												<MultiSelect
													items={lockerName}
													name={"lockerId"}
													value={addRedemptionVars.lockerId}
													// onChange={(e) => {
													// 	handleChange();
													// 	setSelectedLockerName(e.target.value);
													// }}
													onChange={handleChange}
												/>
											</div>
										</div>
										{/* </div> */}
									</div>
								</div>
							</div>
						</div>

						<div className="w-full px-9">
							<Divider className=" border border-gray-200 px-11"></Divider>
						</div>

						<div>
							<Card className="bg-[#F8EED4] font-montserrat">
								<div className="font-bold text-black text-lg  ">
									Campaign Details:
								</div>

								<div className="flex flex-col gap-3 px-2">
									<div className="grid grid-cols-6 items-center">
										<label className="col-span-1 flex items-center">
											<Tooltip
												icon2={"pi pi-question-circle"}
												className={"pr-1 items-center mt-0"}
												message={
													<div>
														<p className="font-bold text-orange-400">
															Campaign Redemption Limit:
														</p>
														<p className="indent-5">
															Total number of times the code could be redeemed
															throughout the whole campaign period.{" "}
														</p>
														<div className="my-4"></div>
														<p className="font-bold text-orange-400">
															Per person Redemption Limit:
														</p>
														<p className="indent-5">
															Total number of times the could could be redeemed{" "}
															<i>
																<b>per mobile number</b>
															</i>{" "}
															thoughout the whole campaign period.
														</p>

														<div className="my-6"></div>

														<p>
															Note: Setting the limit to "0" will make the
															redemption code unlimited use.
														</p>
													</div>
												}
											></Tooltip>
											Redemption Limit
										</label>

										<div className="col-span-5 space-y-2">
											<div className="grid grid-cols-8 items-center">
												<label className="col-span-1">Campaign:</label>
												<InputNumber
													showButtons
													className="w-full col-span-2"
													buttonLayout="horizontal"
													prefix={
														addRedemptionVars.redemptionLimit.campaign < 1
															? "no limit ("
															: null
													}
													suffix={
														addRedemptionVars.redemptionLimit.campaign < 1
															? ")"
															: null
													}
													step={1}
													// readOnly={isReadonly}
													min={0}
													value={addRedemptionVars.redemptionLimit.campaign}
													// name="campaign"
													onValueChange={handleChange}
													name="redemptionLimit.campaign"
													incrementButtonIcon="pi pi-plus"
													decrementButtonIcon="pi pi-minus"
													pt={{
														incrementButton: {
															className: "bg-primary-primaryYellow",
														},
														decrementButton: {
															className: "bg-primary-primaryYellow",
														},
														root: {
															className:
																"border border-gray-200 rounded-lg w-full h-10",
														},
														//
													}}
												/>
											</div>

											<div className="grid grid-cols-8 items-center">
												<label className="col-span-1">Per person:</label>
												<InputNumber
													showButtons
													min={0}
													prefix={
														addRedemptionVars.redemptionLimit.person < 1
															? "no limit ("
															: null
													}
													suffix={
														addRedemptionVars.redemptionLimit.person < 1
															? ")"
															: null
													}
													onValueChange={handleChange}
													value={addRedemptionVars.redemptionLimit.person}
													name="redemptionLimit.person"
													className="w-full col-span-2"
													buttonLayout="horizontal"
													step={1}
													incrementButtonIcon="pi pi-plus"
													decrementButtonIcon="pi pi-minus"
													pt={{
														incrementButton: {
															className: "bg-primary-primaryYellow",
														},
														decrementButton: {
															className: "bg-primary-primaryYellow",
														},
														root: {
															className:
																"border border-gray-200 rounded-lg w-full h-10",
														},
													}}
												/>
											</div>
										</div>
									</div>

									<div className="grid grid-cols-6 items-center">
										<div className="col-span-5">
											<div className="grid grid-cols-5 items-center">
												<label className="col-span-1">Redemption Code:</label>

												<div className="col-span-2">
													<Textfield
														name={"redemptionCode"}
														onChange={handleChange}
													/>
												</div>

												<div className="grid grid-cols-8 items-center">
													<button className="items-center flex justify-center h-full">
														{isCopied ? (
															<i className="fas fa-check text-green-400"></i>
														) : (
															<i
																className="fas fa-copy"
																onClick={copyToClipboard}
															></i>
														)}
													</button>
												</div>
											</div>
										</div>
									</div>

									<div className="grid grid-cols-6 items-center">
										<div className="col-span-5">
											<div className="grid grid-cols-5 items-center">
												<label className="col-span-1">Reward Type:</label>

												<div className="col-span-2">
													<TextFieldDropdown
														isDisabled={true}
														className="my-class"
														placeholder="0"
														minFractionDigits={2}
														min={0}
														dropdownOptions={[
															{ label: "MBOX coins", value: 1 },
															{ label: "prize", value: 2 },
														]}
														dropdownId={selectedReward.value}
														inputNumberName={"rewardType"}
														onValueChange={handleChange}
														// typeName={selectedReward.label}
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</Card>
						</div>

						<div className="w-full px-9">
							<Divider className=" border border-gray-200 px-11"></Divider>
						</div>

						<div>
							<div className="px-[1.25rem]">
								{/* <div className="font-bold text-black text-lg  ">Others:</div> */}

								<div className="px-2 grid grid-cols-12">
									<div className="col-span-6">
										<div className="grid grid-cols-12">
											<label className="col-span-4">Remarks:</label>
											<div className="col-span-8">
												<Textarea
													className="w-full"
													rows={5}
													onChange={handleChange}
													name={"remarks"}
													value={addRedemptionVars.remarks}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="grid grid-cols-12 gap-2 py-3">
							<div className="col-span-5"></div>
							<Button
								className={
									"p-2 font-normal mx-auto border bg-white border-primary-primaryYellow px-3"
								}
								value={"Cancel"}
								// onClick={() => setOpenCancelModal(true)}
							/>
							<Button
								className={"p-2 mx-auto px-5"}
								value={"Save"}
								onClick={() => validateFields()}
							/>
						</div>
					</div>
				</div>

				<Modal
					icon={errorValidation.icon}
					title={errorValidation.title}
					message={errorValidation.message}
					open={errorValidation.open}
					actions={errorValidation.actions}
				/>
			</ContentContainer>
		</>
	);
};

export default AddRedemptionCodeCampaign;
